export function getRateCardModifierSemantics(modifier = {}) {
    const scopeKind = modifier.scope?.kind || "whole-regime"
    const scopeValue = modifier.scope?.value ?? null
    const applyTo = modifier.type === "percentage" ? modifier.applyTo || "running" : "running"

    return {
        scopeKind,
        scopeValue,
        applyTo,
        useBase: modifier.type === "percentage" && applyTo === "base",
    }
}

export function modifierAffectsRunningScope(modifier, targetModifier) {
    const source = getRateCardModifierSemantics(modifier)
    const target = getRateCardModifierSemantics(targetModifier)

    if (target.scopeKind === "whole-regime") return true
    return source.scopeKind === target.scopeKind && source.scopeValue === target.scopeValue
}
